var map = {
	"./base16-dark.css": 141,
	"./base16-light.css": 142
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;


//////////////////
// WEBPACK FOOTER
// ./~/codemirror/theme ^\.\/.*\.css$
// module id = 97
// module chunks = 1